export enum PieceType{
    PAWN = 'pawn',
    KNIGHT = 'knight',
    BISHOP = 'bishop',
    ROOK = 'rook',
    QUEEN = 'queen',
    KING = 'king'
}

export enum TeamType{
    OPPONENT = 'b',
    ALLY = 'w'
}